<ion-content *ngIf="tabs" class="page">
  <app-tabs class="sub-tabs logs" [renderTabs]="tabs"></app-tabs>
  <ion-router-outlet
    class="outlet"
    [ngClass]="getRouterClass()"
    [animated]="false"
  ></ion-router-outlet>
</ion-content>
